import { type RefObject, useRef } from "react";
import { useScroll } from "react-use";

export const useMainScroll = () => {
  const mainRef = useRef<HTMLElement | null>(null);

  // Initialize ref with main element on first render
  if (!mainRef.current) {
    mainRef.current = document.querySelector("main");
  }

  // https://github.com/streamich/react-use/issues/2612
  return useScroll(mainRef as RefObject<HTMLElement>);
};
